export class InternalError extends Error {
  constructor() {
    super()
    this.name = this.constructor.name
  }
}
